import { w as o } from "./index760.mjs";
var r = o, a = r("toStringTag"), t = {};
t[a] = "z";
var S = String(t) === "[object z]";
export {
  S as t
};
